import { motion, useReducedMotion } from 'motion/react';
import { ArrowRight } from '@phosphor-icons/react';
import { AmbientBackground } from './AmbientBackground';
import { AiFollowUpVisual } from './AiFollowUpVisual';
import { HeroCarousel } from './motion/HeroCarousel';

const slides = [
  {
    headline: 'Let AI chase your emails for you',
    subtext:
      'CC us on any email you send. We extract the follow-up window and keep chasing until you get a response.',
  },
  {
    headline: 'Never write a follow-up email again',
    subtext: 'We track every open thread, draft the reminder, and send it right on schedule.',
  },
  {
    headline: 'From invoices to house purchases',
    subtext: "Whatever you're waiting to hear back on, we keep chasing it until you get an answer.",
  },
  {
    headline: "Your inbox's personal assistant",
    subtext: 'We follow up, verify the reply is good enough, and close the loop, automatically.',
  },
];

const container = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.12, delayChildren: 0.1 } },
};

function itemVariants(reduce) {
  return {
    hidden: reduce ? {} : { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: [0.16, 1, 0.3, 1] } },
  };
}

export function Hero() {
  const reduce = useReducedMotion();

  return (
    <section className="relative overflow-hidden">
      <AmbientBackground />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-24">
        <motion.div
          initial="hidden"
          animate="visible"
          variants={container}
          className="grid lg:grid-cols-[1.1fr_0.9fr] gap-16 items-center"
        >
          <div>
            <motion.div variants={itemVariants(reduce)}>
              <HeroCarousel slides={slides} />
            </motion.div>
            <motion.div variants={itemVariants(reduce)} className="mt-10 flex flex-wrap gap-4">
              <motion.a
                href="/app"
                whileHover={reduce ? undefined : { scale: 1.03 }}
                whileTap={reduce ? undefined : { scale: 0.97 }}
                className="group relative overflow-hidden px-8 py-3 bg-indigo-600 text-white rounded-lg text-base font-semibold shadow-lg shadow-indigo-600/30"
              >
                <span className="relative z-10 flex items-center gap-2">
                  Get Started
                  <ArrowRight weight="bold" className="transition-transform duration-300 group-hover:translate-x-1" />
                </span>
                <span className="absolute inset-0 -translate-x-full bg-indigo-500 transition-transform duration-300 group-hover:translate-x-0" />
              </motion.a>
              <motion.a
                href="#how-it-works"
                whileHover={reduce ? undefined : { scale: 1.03 }}
                whileTap={reduce ? undefined : { scale: 0.97 }}
                className="px-8 py-3 rounded-lg text-base font-semibold border border-white/15 bg-white/5 text-zinc-200 hover:bg-white/10 transition-colors"
              >
                How It Works
              </motion.a>
            </motion.div>
          </div>

          <motion.div variants={itemVariants(reduce)} className="relative mx-auto w-full max-w-md">
            <AiFollowUpVisual />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
